import { MutableRefObject, useRef } from 'react'
import { Class_MenuConfig, keyTypeConfig, keyTypeElements } from '../deps/OpenSankey/types/MenuConfig'
import { OSPShowMenuComponentsVarType } from './LegacyTypes'

export type keyTypeConfigOSP = keyTypeConfig | 'presentation'
export type keyTypeElementsOSP = keyTypeElements | 'data_tag' | 'tag_flow' | 'tag_node' | 'view'
export class Class_MenuConfigOSP extends Class_MenuConfig {
  protected override _menu_top_order = [...super.menu_top_order, ['diagrams', 'views', 'afm', 'edit']]
  private _dict_setter_show_dialog_plus: OSPShowMenuComponentsVarType

  private _ref_to_node_hyperlink_updater: MutableRefObject<(() => void)>

  private _ref_to_btn_top_pref_updater: MutableRefObject<(() => void)>

  private _ref_to_config_DA_bg_image_updater: MutableRefObject<(() => void)>
  private _ref_to_banner_views_updater: MutableRefObject<() => void>
  private _ref_to_banner_views_opened: MutableRefObject<boolean>
  private _ref_to_views_config_updater: MutableRefObject<() => void>
  private _ref_to_modal_view_attributes_switcher: MutableRefObject<(_: boolean) => void>
  private _ref_to_modal_view_attr_updater: MutableRefObject<() => void>

  private _ref_show_modal_unitary_view: MutableRefObject<(_: boolean) => void>
  private _ref_update_modal_unitary_view: MutableRefObject<() => void>

  constructor() {
    super()

    this._ref_to_banner_views_updater = useRef(() => null)
    this._ref_to_banner_views_opened = useRef(false)
    this._ref_to_views_config_updater = useRef(() => null)

    this._ref_to_modal_view_attributes_switcher = useRef((_: boolean) => null)
    this._ref_to_modal_view_attr_updater = useRef(() => null)
    this._ref_show_modal_unitary_view = useRef((_: boolean) => null)
    this._ref_update_modal_unitary_view = useRef(() => null)

    this._ref_to_btn_top_pref_updater = useRef(() => null)
    this._ref_to_node_hyperlink_updater = useRef(() => null)
    this._ref_to_config_DA_bg_image_updater = useRef(() => null)

    this._dict_setter_show_dialog_plus = {ref_setter_show_menu_view_not_saved: useRef(() => null)}

    //this._style_config.data.elements_configurable.push('data_tag')
    this._style_config.presentation.elements_configurable.push('level_tag')
  }

  updateAllMenuComponents(): void {
    super.updateAllMenuComponents()
    this.updateComponentRelatedToContainers()
    this.updateComponentRelatedToViews()
    this._ref_to_config_DA_bg_image_updater.current()
    this._ref_to_btn_top_pref_updater.current()
  }

  public updateComponentRelatedToViews() {
    this._ref_to_banner_views_updater.current()
    this._ref_to_views_config_updater.current()
    this._ref_to_modal_view_attr_updater.current()
    this.updateComponentSaveDiagramJSON()
    this.updateComponentLoadDiagramJSON()
  }

  public override updateAllComponentsRelatedToNodesConfig() {
    super.updateAllComponentsRelatedToNodesConfig()
    this._ref_to_node_hyperlink_updater.current()
  }

  public override updateAllComponentsRelatedToNodeTags() {
    super.updateAllComponentsRelatedToNodeTags()
    this._ref_update_modal_unitary_view.current()
  }

  public override updateAllComponentsRelatedToLevelTags() {
    super.updateAllComponentsRelatedToLevelTags()
    this._ref_update_modal_unitary_view.current()
  }

  public updateComponentRelatedToLinksData() {
    this.ref_to_menu_config_links_data_updater.current()
    this.ref_to_spreadsheet.current()
    this.ref_to_menu_contextual_config_links_data_updater.current()
  }

  public get dict_setter_show_dialog_plus(): OSPShowMenuComponentsVarType { return this._dict_setter_show_dialog_plus }
  public get ref_to_banner_views_updater(): MutableRefObject<() => void> { return this._ref_to_banner_views_updater }
  public get ref_to_banner_views_opened() { return this._ref_to_banner_views_opened }
  public get ref_to_views_config_updater(): MutableRefObject<() => void> { return this._ref_to_views_config_updater }
  public get ref_to_modal_view_attributes_switcher(): MutableRefObject<(_: boolean) => void> { return this._ref_to_modal_view_attributes_switcher }
  public get ref_to_modal_view_attr_updater(): MutableRefObject<() => void> { return this._ref_to_modal_view_attr_updater }
  public get ref_show_modal_unitary_view(): MutableRefObject<(_: boolean) => void> { return this._ref_show_modal_unitary_view }
  public get ref_update_modal_unitary_view(): MutableRefObject<() => void> { return this._ref_update_modal_unitary_view }

  public get ref_to_node_hyperlink_updater(): MutableRefObject<(() => void)> { return this._ref_to_node_hyperlink_updater }

  public get ref_to_config_DA_bg_image_updater() { return this._ref_to_config_DA_bg_image_updater }
  public get ref_to_btn_top_pref_updater() { return this._ref_to_btn_top_pref_updater }
}